export const EUROPA_ISO_2_CODES = [
  'ad',
  'al',
  'am',
  'at',
  'az',
  'ba',
  'be',
  'bg',
  'by',
  'ch',
  'ch',
  'cy',
  'cz',
  'de',
  'dk',
  'ee',
  'es',
  'fi',
  'fr',
  'gb',
  'gb',
  'ge',
  'gr',
  'hr',
  'hu',
  'ie',
  'is',
  'it',
  'li',
  'lt',
  'lu',
  'lv',
  'mc',
  'md',
  'me',
  'mk',
  'mt',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'rs',
  'ru',
  'se',
  'si',
  'sk',
  'sm',
  'tr',
  'ua',
  'va',
];
